import { domReady } from '../helpers';

export function initHomePage() {
	
}

domReady(() => {
	initHomePage();
});
